module.exports = __webpack_public_path__ + "img/service_icon_4.38b3c471.svg";